<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';

    export let notificationId = null;
    export let closeCallback;

    let notification = null;


    const load = () => {

        const onSuccess = result => {
            notification = result;
        };

        const onFailure = err => {
        };

        R.handle(R.notification.preview, notificationId, onSuccess, onFailure, LOADER.POPUP);
    };


    const close = () => {
        notification = null;

        setTimeout(() => {
            closeCallback();
        }, 200);
    }

    load();
</script>


{#if notification}
    <Modal modalLg title="Ειδοποίηση" icon="mail" closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <div>
                {@html notification }
            </div>
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link" on:click="{ () => close() }">Κλείσιμο</div>
            </div>
        </div>
    </Modal>
{/if}